"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Premium = function Premium(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 18 13"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-443.000000, -118.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(443.000000, 118.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.540662,13 L1.45937295,13 C1.15045924,13 0.9,12.7815322 0.9,12.5121069 L0.9,10.0212264 C0.9,9.75177063 1.15045924,9.53333333 1.45937295,9.53333333 L16.5406271,9.53333333 C16.8495408,9.53333333 17.1,9.75180112 17.1,10.0212264 L17.1,12.5121069 C17.1,12.7815627 16.8496107,13 16.540662,13 Z",
    fill: "#FFC733"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.540662,9.53333333 L9,9.53333333 L9,13 L16.5406271,13 C16.8495408,13 17.1,12.7815341 17.1,12.5121112 L17.1,10.0212526 C17.1,9.75176871 16.8495757,9.53333333 16.540662,9.53333333 Z",
    fill: "#FFAF00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.0138748,1.25423263 L13.1432708,5.56922574 L9.46672958,0.242000549 C9.24404952,-0.0806154376 8.75611513,-0.0807182579 8.5333296,0.242000549 L4.85678839,5.56922574 L0.986184353,1.25423263 C0.62618376,0.852959073 -0.0517704822,1.1410617 0.00314367081,1.67041513 L0.854699762,9.87928347 L0.854699762,10.4 C1.59291192,10.4 16.5530811,10.4 17.145254,10.4 L17.145254,9.87928347 L17.9968452,1.67041513 C18.0518648,1.1409246 17.37377,0.85302762 17.0138748,1.25423263 Z",
    fill: "#FFE365"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.0137843,1.25424466 L13.1431927,5.56926443 L9.46666333,0.242006327 C9.35532366,0.0806802004 9.17764425,0 9,0 L9,10.4 C12.9246618,10.4 16.8477767,10.4 17.1452684,10.4 L17.1452684,9.87928025 L17.9968569,1.67036119 C18.0517709,1.14093593 17.3736782,0.853037174 17.0137843,1.25424466 Z",
    fill: "#FFC733"
  })))));
};
/* eslint-enable */
var _default = Premium;
exports["default"] = _default;